<script>
import Nav from "@/components/Nav/index.vue";
import { nextTick } from "vue";
import axios from "axios";
export default {
    name: "NcoinRecord",
    data() {
        return {
            descriptionTarget: '',
            history: [],
            expiring_points: 0
        };
    },
    components: {
        Nav,
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
        userLineInfo() {
            return this.$store.state.userLineInfo;
        },
        hostUrl() {
            return this.$store.state.hostUrl;
        },
        yearEndDate() {
            return `${new Date().getFullYear()}/12/31`;
        },
        shopBaseUri() {
            return process.env.VUE_APP_shopLiffUri;
        },
    },
    watch: {
    },
    mounted() {
        const _this = this;
        nextTick(() => {});
        const today = new Date()
        const format = d => d.toISOString().split('T')[0]
        this.maxDate = format(today)
        console.log(this.userNbInfo)
        _this.$store.commit("loadingToggle", true);
        axios.get(`${_this.hostUrl}member/points`, {
            headers: {
                Authorization: `Bearer ${_this.$store.state.userNbInfo.access_token}`,
            }
        }).then(response => {
            console.log(response.data.data)
            _this.history = response.data.data.history
            _this.expiring_points = response.data.data.expiring_points
            nextTick(() => {
                _this.$store.commit("loadingToggle", false);
            });
        }).catch(error => {
            console.error(error);
        });
    },
    methods: {      
        changeToLocaleString(str) {
            // console.log("changeToLocaleString", str);
            return typeof str === "number" ? str.toLocaleString() : "0";
        },
        showDescription(target) {
            // console.log("showDescription");
            let vm = this;
            if (target === vm.descriptionTarget) {
                vm.descriptionTarget = "";
            } else {
                vm.descriptionTarget = target;
            }
        },  
        
    },
};
</script>

<template src="./template.pug" lang="pug"></template>

<style src="./style.sass" lang="sass" scoped></style>
